import { useState, useEffect } from 'react';
import styled from 'styled-components';
import { toaster } from '../../helpers/toaster';
import { Form, TextInput, Button, Loading } from 'carbon-components-react';

import MyModal from '../../components/Modal/Modal';
import { addDevelopmentStatus, updateDevelopmentStatus } from '../../api/developmentStatuss';

const NewDevelopmentStatusModal = ({
  mode = "create",
  open = false,
  developmentStatusData,
  refreshList = () => {},
  onClose = () => {},
}) => {
	// loading is for initial component preloading
	const [loading, setLoading] = useState(false);
  const [modalMode, setModalMode] = useState(false);
	// processing is for user initiated component api calls
	const [processing, setProcessing] = useState(false);
  const [developmentStatusInfo, setDevelopmentStatusInfo] = useState(null);
  const [name, setName] = useState("");
  const [url, setUrl] = useState("");

  const onlyAttachment = localStorage.getItem('only_attachment')

  useEffect(() => setModalMode(mode), [mode]);
  useEffect(() => {
    if(developmentStatusData){
      setDevelopmentStatusInfo(developmentStatusData);
      setName(developmentStatusData?.name);
      setUrl(developmentStatusData?.url);
    }
    else{
      setName("");
      setUrl("");
    }
  }, [developmentStatusData]);
  const addBtnStyle = {
    padding: "11px 18px",
    height: "auto",
    minHeight: "unset",
    borderRadius: "10px",
    fontFamily: "'Plus Jakarta Sans', system-ui, sans-serif",
    fontWeight: 700,
    fontSize: "13.5px",
    width: "fit-content",
    marginLeft: "10px",
  };

  const onChangeName = (input) => {
    setName(input);
  };

  const onChangeUrl = (input) => {
    setUrl(input);
  };

  const saveDevelopmentStatus = (e) => {
    e.preventDefault();
    
    if (!name) {
      toaster("Please enter name", "warning")
      return;
    }
    
    setProcessing(true);
    if(modalMode === "create"){
      addDevelopmentStatus(name).then(res => {
        toaster("Added new development status", "success")
        setName("");
        setUrl("")
        onClose();
        refreshList();
        setProcessing(false);
      }).catch(error => {
        toaster("Failed to create new DevelopmentStatus", "error")
        setProcessing(false);
      });
    } else{
      updateDevelopmentStatus(developmentStatusInfo.id, {name:name}).then(res =>{
        toaster("DevelopmentStatus updated successfully", "success")
        onClose();
        refreshList();
        setProcessing(false);
      }).catch(error => {
        toaster("Failed to update global developmentStatus", "error")
        setProcessing(false);
      });;
    };
  }

  
	const additionalProps = {
		className: 'some-class',
		onSubmit: saveDevelopmentStatus
	};
  
  return (
    <MyModal
      modalHeading="Development Status Details"
      size="sm"
      open={open}
      onRequestClose={onClose}
    >
      <ModalContent>

      {
					processing || loading ? 
					<Loading/> 
					:
					<></>
				}
				
				<Form {...additionalProps}>

          <div style={{ marginBottom: "18px" }}>
            <TextInput
              value={name}
              labelText="Development Status Name*"
              // placeholder="Please enter DevelopmentStatus Name"
              onChange={e => onChangeName(e.target.value)}
              required
            />
          </div>


          <ModalFooter>

          <Button 
              kind="secondary"
              onClick={onClose}
              style={addBtnStyle}  
            >Cancel</Button>

            <Button
              type="submit"
              kind="primary"
              // onClick={() => onCreate()}
              style={addBtnStyle}  
              disabled={onlyAttachment === "true"}
            >{ (modalMode === "create") ? "Create Development Status" : "Update Development Status" }</Button>
          </ModalFooter>

        </Form>

      </ModalContent>
    </MyModal>
  );
};

export default NewDevelopmentStatusModal;

const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
`

const ModalFooter = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
`
